module.exports = __webpack_public_path__ + "assets/media/day16.692e8b40.mp3";